import { h } from 'preact';

export const CreditCardIcon = () => (
	<svg width="18" height="18" style={{ minWidth: 18 }} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15.75 3H2.25C1.42157 3 0.75 3.67157 0.75 4.5V13.5C0.75 14.3284 1.42157 15 2.25 15H15.75C16.5784 15 17.25 14.3284 17.25 13.5V4.5C17.25 3.67157 16.5784 3 15.75 3Z"
			stroke="#262626" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M0.75 7.5H17.25" stroke="var(--text-primary)" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
);

export const ShieldIcon = () => (
	<svg width="18" height="18" style={{ minWidth: 18 }} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 16.5C9 16.5 15 13.5 15 9V3.75L9 1.5L3 3.75V9C3 13.5 9 16.5 9 16.5Z" stroke="var(--text-primary)" stroke-width="1.33333"
		      stroke-linecap="round"
		      stroke-linejoin="round"/>
	</svg>
);

export const ClockIcon = () => (
	<svg width="18" height="18" style={{ minWidth: 18 }} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
		      stroke="var(--text-primary)" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M9 4.5V9L12 10.5" stroke="var(--text-primary)" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
);
